
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';


import SettingsMenu from './SettingsMenu';

const TopBar = ({ offlineMode, setOfflineMode, 
                numStories, setNumStories,
                staleAfterMins, setStaleAfterMins }) => {

    const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);
  
    const handleOfflineModeChange = (event) => {
      const newOfflineMode = !offlineMode;
      setOfflineMode(newOfflineMode);
      localStorage.setItem('offlineMode', newOfflineMode)
    };

    const toggleSettingsMenu = () => {
      setSettingsMenuOpen(!settingsMenuOpen);
    };

    const location = useLocation();

    return ( 
        <div className="App-header flex justify-between items-center">
            <Link to={`/`} >
                <div className='flex gap-2 items-center ml-[10px]'>
                    {location.pathname.startsWith('/story/') ? 
                        <i className="fa-solid fa-arrow-left mt-[2px]"></i> :
                        <div className='w-[14px]'/>
                    } 
                    <h1>Hacker News</h1>
                </div>
            </Link>
            <div className="flex items-center gap-7 mr-[20px]">
                <div className='w-[25px] h-[25px]' onClick={handleOfflineModeChange}>
                    {offlineMode ? (
                    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24">
                        <rect width="24" height="24" fill="none" />
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 18.004H6.657C4.085 18 2 15.993 2 13.517s2.085-4.482 4.657-4.482c.393-1.762 1.794-3.2 3.675-3.773c1.88-.572 3.956-.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.37 0 2.556.8 3.117 1.964M22 22l-5-5m0 5l5-5" />
                    </svg>) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <rect width="24" height="24" fill="none" />
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 18.004H6.657C4.085 18 2 15.993 2 13.517s2.085-4.482 4.657-4.482c.393-1.762 1.794-3.2 3.675-3.773c1.88-.572 3.956-.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.388 0 2.585.82 3.138 2.007M15 19l2 2l4-4" />
                    </svg>
                    )}
                </div>
                <div id='settings' className='w-[25px] h-[25px]'>
                    <svg onClick={toggleSettingsMenu} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <rect width="24" height="24" fill="none" />
                        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                        <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37c1 .608 2.296.07 2.572-1.065" />
                        <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0-6 0" />
                        </g>
                    </svg>
                </div>
            </div>
            {settingsMenuOpen && (
                <SettingsMenu
                    numStories={numStories} setNumStories={setNumStories}
                    staleAfterMins={staleAfterMins} setStaleAfterMins={setStaleAfterMins} 

                    onClose={toggleSettingsMenu}
                />
            )}
        </div>
    );
};

export default TopBar;